export default __webpack_public_path__ + "static/media/residential_construction.aae961a8.jpg";